
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SetMasterDialog extends Serenity.EntityDialog<SetMasterRow, any> {
        protected getFormKey() { return SetMasterForm.formKey; }
        protected getIdProperty() { return SetMasterRow.idProperty; }
        protected getLocalTextPrefix() { return SetMasterRow.localTextPrefix; }
        protected getNameProperty() { return SetMasterRow.nameProperty; }
        protected getService() { return SetMasterService.baseUrl; }
        protected getDeletePermission() { return SetMasterRow.deletePermission; }
        protected getInsertPermission() { return SetMasterRow.insertPermission; }
        protected getUpdatePermission() { return SetMasterRow.updatePermission; }

        protected form = new SetMasterForm(this.idPrefix);

    }
}